/**
 * @return {{click: string}}
 */
export const lumnizCoin = () => ({
  click: 'interet_gamification',
});
